import { Button, Checkbox, message, Modal, Spin } from "antd";
import CustomEmpty from "components/CourseComponents/CustomEmpty";
import ResultMessage from "components/CourseComponents/ResultMessage";
import LoadMore from "components/LoadMore";
import { useAtomValue } from "jotai";
import React, { useEffect, useState } from "react";
import {
    clearReadAll,
    getMessageReceiveList,
    markReadAll,
    ReceiveListItem,
    updateMessageReceiveRead
} from "service/notice";
import { errorMessage } from "service/service";
import usePromiseCallback from "utils/usePromiseCallback";
import useRequestFn from "utils/useRequestFn";
import { unReadCountAtom, useUpdateCounts } from "../store";
import NoticeItem from "./components/NoticeItem";
import styles from "./index.module.scss";

export default function PageReceive() {
    const PAGE_SIZE = 3;
    const [pageNo, setPageNo] = useState(1);
    const [hasMore, setHasMore] = useState(false); // 是否还有下一页
    const [currentId, setCurrentId] = useState(0); // 当前展开的
    const [readFlag, setReadFlag] = useState<number>(0); // 0：显示全部 1:显示未读

    const [list, setList] = useState<ReceiveListItem[]>([]);
    const counts = useAtomValue(unReadCountAtom); //获取未读数目
    const updataCounts = useUpdateCounts(); //更新未读数目

    const [getList, { loading }] = useRequestFn(getMessageReceiveList); //获取列表数据
    const [updataReadState] = useRequestFn(updateMessageReceiveRead); //获取未读数目

    useEffect(() => {
        loadData(pageNo, PAGE_SIZE, readFlag);
    }, [readFlag]);

    // 加载更多
    const loadMore = usePromiseCallback(async () => {
        const newPage = pageNo + 1;
        setPageNo(newPage);
        await loadData(newPage, PAGE_SIZE, readFlag, false);
    });

    // 加载数据
    async function loadData(
        pageNo: number,
        pageSize: number,
        readFlag: number,
        clear: boolean = true
    ) {
        try {
            const data = await getList(pageNo, pageSize, readFlag);
            setList(clear ? data.dataList : [...list, ...data.dataList]);
            setHasMore(data.allRowNum / pageSize > pageNo);
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    }

    //未读、已读切换
    const handleviewOrUnread = (e: any) => {
        const flag = e.target.checked ? 1 : 0;

        setList([]);
        setPageNo(1);
        setReadFlag(flag);
    };

    //全部标记已读
    const handleMarkReadAll = () => {
        Modal.confirm({
            icon: "exclamation-circle",
            title: "确定把未读的通知设为已读吗?",
            onOk: async () => {
                setPageNo(1);

                try {
                    await markReadAll();
                    await updataCounts();
                    await loadData(1, PAGE_SIZE, readFlag);
                } catch (e) {
                    message.error(errorMessage(e));
                }
            }
        });
    };

    //清空已读
    const handleClearReadAll = () => {
        Modal.confirm({
            icon: "exclamation-circle",
            title: "确定清空已读的通知吗？",
            onOk: async () => {
                setPageNo(1);

                try {
                    await clearReadAll();
                    await loadData(1, PAGE_SIZE, readFlag);
                    message.success("已读通知已全部清空");
                } catch (e) {
                    message.error(errorMessage(e));
                }
            }
        });
    };

    const onclickItem = async (id: number) => {
        setCurrentId(currentId === id ? 0 : id);
        const newList = list.map(item => ({
            ...item,
            readStatus: item.id === id ? "1" : item.readStatus
        }));
        setList(newList);
        await updataReadState(id);
        await updataCounts();
    };

    return (
        <div className={styles.root}>
            <div className={styles.head}>
                <Checkbox
                    onChange={handleviewOrUnread}
                    className={styles.checkStyle}>
                    仅查看未读消息
                    <span style={{ color: "#FF2E3E" }}>（{counts || 0}）</span>
                </Checkbox>

                <div className={styles.button}>
                    <Button type="link" onClick={handleMarkReadAll}>
                        全部标记已读
                    </Button>
                    <Button type="link" onClick={handleClearReadAll}>
                        清空已读
                    </Button>
                </div>
            </div>

            <Spin spinning={loading}>
                <div className={styles.body}>
                    {!list?.length && (
                        <CustomEmpty
                            style={{ padding: "160px 0" }}
                            description="暂无消息"
                        />
                    )}
                    {!!list?.length &&
                        list.map(item => (
                            <NoticeItem
                                key={item.id}
                                data={item}
                                onClick={() => onclickItem(item.id)}
                                active={currentId === item.id}
                            />
                        ))}

                    <LoadMore onVisible={loadMore} hasMore={hasMore} />
                </div>
            </Spin>
        </div>
    );
}
